import { Box, Typography } from "@mui/material"

export function DurationLabel({ minutes }) {
    if (typeof minutes !== "number" || Number.isNaN(minutes)) return null
    let wholeMinutes = Math.floor(minutes)
    let seconds = Math.round((minutes % 1) * 60)
    if (seconds === 60) {
        wholeMinutes++
        seconds = 0
    }
    const label = seconds !== 0 ? `${wholeMinutes}m ${seconds}s` : `${wholeMinutes}m`
    return (
        <Box minWidth="3.3em" ml={1}>
            <Typography variant="body2" component="span">
                {label}
            </Typography>
        </Box>
    )
}
